import React from 'react';
import type { TemplatePageResponseT } from 'shared/cms/pickTemplateResponse';
import type { BoxT } from '@mentimeter/ragnar-ui/box';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Overlay } from './Overlay';
import { Featured } from './Featured';
import { Default } from './Default';

interface Props extends BoxT {
  template: TemplatePageResponseT;
  featTemplateBgColor?: string | undefined;
  isFeatured?: boolean;
  previewUrl: string;
}

export const TemplateCard = React.memo(
  ({
    template,
    featTemplateBgColor = 'neutralWeakest',
    isFeatured = false,
    previewUrl,
    extend,
    ...styleProps
  }: Props) => {
    const {
      previewImage,
      questionId,
      shortDescription,
      usesProFeatures,
      numberOfSlides,
      presentationId,
      title,
    } = template;

    return (
      <Box
        borderColor="borderWeak"
        borderRadius={2}
        borderStyle="solid"
        borderWidth="2px"
        overflow="hidden"
        extend={({ theme }) => ({
          ':hover': {
            borderColor: theme.colors.primary,
            transition: `border-color ${theme.durations[2]}s`,
          },
          ...extend?.({ theme }),
        })}
        {...styleProps}
      >
        {isFeatured ? (
          <Featured
            featTemplateBgColor={featTemplateBgColor}
            previewImage={previewImage}
            presentationId={presentationId}
            questionId={questionId}
            isPro={usesProFeatures}
            title={title}
            numberOfSlides={numberOfSlides}
          />
        ) : (
          <Default
            previewImage={previewImage}
            presentationId={presentationId}
            questionId={questionId}
            isPro={usesProFeatures}
            title={title}
            numberOfSlides={numberOfSlides}
          />
        )}
        <Overlay
          description={shortDescription || title}
          presentationId={presentationId}
          previewUrl={previewUrl}
          title={title}
        />
      </Box>
    );
  },
);
